import type { TOptionsBase } from 'i18next';

interface SitecoreTranslation {
    [key: number]: number | string;
    [key: string]: number | string;
}

export const sitecoreTranslation = (value: SitecoreTranslation): TOptionsBase => ({
    ...value,
    interpolation: {
        prefix: '{',
        suffix: '}',
    },
});
